import { render, staticRenderFns } from "./description.vue?vue&type=template&id=2e96cbef"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiReadMore: require('/vercel/path0/components/ui/read-more.vue').default,UiContainer: require('/vercel/path0/components/ui/container.vue').default})
